import theme from '@/constants/theme';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import React from 'react';

interface Props {
  type: HTMLInputElement['type'];
  setType: React.Dispatch<React.SetStateAction<HTMLInputElement['type']>>;
}

const ShowOrHidePasswordButton: React.FC<Props> = ({ type, setType }) => {
  const handlechangeType = (newType: HTMLInputElement['type']) => {
    setType(newType);
  };

  const handleClickShowPassword = () => {
    if (type === 'password') {
      handlechangeType('text');
    } else {
      handlechangeType('password');
    }
  };

  return (
    <button
      type="button"
      style={{
        position: 'absolute',
        right: 12,
        top: 12,
        backgroundColor: 'transparent',
        border: 'none',
        color: theme.colors.text.caption,
        cursor: 'pointer',
      }}
      onClick={handleClickShowPassword}
    >
      {type === 'password' ? (
        <VisibilityOff aria-label="show password" titleAccess="Mostrar contraseña" />
      ) : (
        <Visibility aria-label="hide password" titleAccess="Ocultar contraseña" />
      )}
    </button>
  );
};

export default ShowOrHidePasswordButton;
